import React, { FC } from 'react';
import { LanguageContext } from './LanguageContext';

export const withLang = (Component: FC<any>) => (props: any) => (
	<LanguageContext.Consumer>
		{(lang) => <Component lang={lang} {...props} />}
	</LanguageContext.Consumer>
);
